import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

function ContentWrapper({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'rounded-lg border border-border bg-card p-4 flex flex-1 flex-col items-start gap-4 w-full',
        className
      )}
    >
      {children}
    </div>
  );
}

export default ContentWrapper;
